export default __webpack_public_path__ + "static/media/matplotlib.f810802c.svg";